import { render, staticRenderFns } from "./AwardNoticeWrapper.vue?vue&type=template&id=69efff4c&scoped=true"
import script from "./AwardNoticeWrapper.vue?vue&type=script&lang=js"
export * from "./AwardNoticeWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69efff4c",
  null
  
)

export default component.exports